import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateBillingConfig } from '@/services/admin/update-billing-config';

export const useUpdateBillingConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      orgId,
      markupPercentage,
    }: {
      orgId: string;
      markupPercentage: number;
    }) => updateBillingConfig(orgId, markupPercentage),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['cross-org-cost'] });
    },
  });
};
